import { ErrorScreen } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import React from "react";

import { CubeCollapsedTileSkeletonStack } from "./CubeCollapsedTileSkeletonStack";
import type { ProContractorRow } from "./parseProContractorRows";
import { ProContractorsStackedBarChart } from "./ProContractorsStackedBarChart";

type Props = {
  rows: ProContractorRow[] | undefined;
  error: Error | null;
  isLoading: boolean;
};

export const ProContractorsBlock: React.FC<Props> = (props) => {
  const theme = useTheme();
  if (props.error) {
    return <ErrorScreen>{props.error.message}</ErrorScreen>;
  }
  if (props.isLoading) {
    return <CubeCollapsedTileSkeletonStack />;
  }
  const rows = props.rows;
  if (rows === undefined || rows.length === 0) {
    return <div css={{ color: theme.colors.secondaryText, fontSize: "0.875rem" }}>Brak danych.</div>;
  }
  return <ProContractorsStackedBarChart rows={rows} />;
};
